import { getSysOptions } from '@/api/basebasic'
import cache from '@/plugins/cache'

//在api/basebasic.js的getSysOptions接口
const optionsetting = cache.local.get('option-setting')
const storageOptions = (optionsetting !== null) ? JSON.parse(optionsetting) : ''

const state = {
  dictMap: new Map(),
  isSetDict: false,
  tenantSchema: storageOptions.tenantSchema || [],
  tenantType: storageOptions.tenantType || [],
  userType: storageOptions.userType || [],
  goodsParamTypes: storageOptions.goodsParamTypes || [],
  dicList: storageOptions.dicList || []
}

const mutations = {
  SET_SCHEMA: (state, tenantSchema) => {
    state.tenantSchema = tenantSchema
  },
}

const actions = {
  //获取系统配置列表
  getSysOption() {
    return new Promise((resolve, reject) => {
      getSysOptions().then(response => {
        const data = response.ResData
        //1.存state
        //commit('SET_SCHEMA', data.tenantSchema)
        //2.存Local   
        cache.local.set('option-setting', JSON.stringify(data))

        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async setDictMap({ dispatch }) {
    const dictMap = cache.local.get('dictype-setting')
    if (dictMap) {
      state.dictMap = JSON.parse(dictMap) 
      state.isSetDict = true
    } else {
      await dispatch('getSysOption').then(async (res) => {
        const data = res.ResData;
        const list = data.dicList;
        // 设置数据
        const dictDataMap = new Map()
        list.forEach((dictData) => {
          // 获得 dictType 层级
          const enumValueObj = dictDataMap[dictData.dictType]
          if (!enumValueObj) {
            dictDataMap[dictData.dictType] = []
          }
          // 处理 dictValue 层级
          dictDataMap[dictData.dictType].push({
            value: dictData.value,
            label: dictData.label,
            colorType: dictData.colorType,
            cssClass: dictData.cssClass || 'defaultcss'
          })
        })
        state.dictMap = dictDataMap
        state.isSetDict = true
        cache.local.set('dictype-setting', JSON.stringify(dictDataMap))
      })
    }
  },
  async getDictByType({ dispatch }, type) {
    if (!state.isSetDict) {
      await dispatch('setDictMap')
    }
    return state.dictMap[type]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
